import(/* webpackMode: "eager" */ "C:\\Users\\bigsa\\Desktop\\ShopAttend\\src\\app\\page.tsx");
